<template>
    <div>
        <div class="panel mb-0">
            <div class="panel-hdr d-block pt-4 p-3">
                <div class="ml-auto text-right mb-3">
                    <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                               :data="exportData"
                               :fields="exportFields"
                               :header="exportHeaders"
                               type="csv"
                               :escapeCsv="false"
                               :name="exportFileName">
                        <span>CSV</span>
                    </exportCSV>
                </div>
                <div class="row">

                    <div class="col-sm-12 col-md-4 align-items-center justify-content-start">
                        <div class="dataTables_filter mb-2">
                            <label class="d-flex mb-0">
                                <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                       :placeholder="$t('label.search')" v-model="filterSearch" @keypress.enter="filterBySearch">
                                <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                                        @click="filterBySearch()">
                                    <i class="fas fa-search"></i>
                                </button>
                            </label>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <date-range-picker
                            class="w-100"
                            ref="picker"
                            v-model="filterDate"
                            :opens="'right'"
                            :autoApply="true"
                            :showDropdowns="true"
                            :always-show-calendars="true"
                            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                            @showCustomRange="showCustomRangeCalendars = true"
                            @update="filterByDate">
                        </date-range-picker>
                    </div>

                    <div class="col-sm-12 col-md-4">
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend w-100">
                                    <label
                                        class="input-group-text border-right-0"
                                        for="serviceCategory">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect
                                        :value="filterOutlet"
                                        label="text"
                                        track-by="id"
                                        :options="outlets"
                                        :searchable="false"
                                        :show-labels="false"
                                        openDirection="below"
                                        @select="filterByOutlet">
                                        <template
                                            slot="option"
                                            slot-scope="{ option }">{{ option.text }}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="mt-3 col-md-6 col-lg-6 col-xl-4 d-flex flex-column">
                        <b-button-group size="sm">
                        <b-button
                            v-for="tab of statusTabs"
                            :key="'statusTabs_' + tab.value"
                            variant="outline-primary"
                            :class="filterStatus === tab.value ? 'active' : ''"
                            @click="filterStatus = tab.value"
                            >
                            {{ tab.text }}
                        </b-button>
                        </b-button-group>
                    </div>
                </div>
                <br>
                <a class="link text-primary" @click="clearFilter">{{ $t('button_link.clear_filter') }}</a>
            </div>
            <div class="panel-container">
                <div class="panel-content">
                    <div v-if="showSpinner" class="d-flex justify-content-center mt-3 mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                    <div class="panel-tag mt-3" v-if="!showSpinner && totalEntries == 0">{{ $t('table.no_records') }}</div>
                    <div class="dataTables_wrapper dt-bootstrap4" v-if="!showSpinner && totalEntries != 0">
                        <div v-if="showPagination" class="row justify-content-end mt-2">
                            <div class="col-auto pt-2">
                                <span>{{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}</span>
                            </div>
                            <div class="col-auto">
                                <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                              @input="handlePagination"></b-pagination>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 overflow-auto">
                                <b-table striped hover :fields="fields" :items="data" responsive>
                                    <template #cell(index)="data">
                                        {{ data.index + startPage }}
                                    </template>
                                    <template #cell(staffName)="data">
                                        <div class="row">
                                            <div class="col-auto">
                                                <img class="profile-image-md rounded-circle" :src="data.item.icon != '' ? getMemberImage(data.item.icon) : require('@/assets/image/icon/profile.png')" />
                                            </div>
                                            <div class="col-auto">
                                                <div class="font-weight-bold">{{ data.item.name }}</div>
                                                <div class="align-middle">
                                                    <span class="badge badge-pill badge-success"><i class="fas fa-phone"></i></span>
                                                    {{ data.item.mobile }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <template #cell(applyDate)="data">
                                        <div class="font-weight-bold">{{ getDate(data.item.createDate) }}</div>
                                        <div class="align-middle">
                                            <span class="badge badge-pill badge-warning"><i class="fas fa-clock"></i></span>
                                            {{ getTime(data.item.createDate) }}
                                        </div>
                                    </template>
                                    <template #cell(leaveDate)="data">
                                        <div><span class="font-weight-bold">Start: </span>{{ getDate(data.item.startDate) }}</div>
                                        <div><span class="font-weight-bold">End: </span>{{ getDate(data.item.stopDate) }}</div>
                                    </template>
                                    <template #cell(leaveType)="data">
                                        {{ data.item.type }}
                                    </template>
                                    <template #cell(status)="data">
                                        <span v-if="data.item.approvedDate" class="badge badge-success">Approved</span>
                                        <span v-else-if="getIsRejected(data.item)" class="badge badge-danger">Rejected</span>
                                        <span v-else class="badge badge-warning">Pending</span>
                                    </template>
                                    <template #cell(action)="data">
                                        <b-button @click="showModal(data.item)" tabindex="0" variant="outline-primary">
                                            <i class="fal fa-pencil fs-xl"></i>
                                        </b-button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import { handleSessionExpired, setReturnData, getMemberMap } from './../../../../assets/js/dashboard/dashboard.js'
import { all } from 'q'
import DateRangePicker from 'vue2-daterange-picker'

export default {
    name: 'rosterList',
    props: {
        outlets: {
            type: Array,
            default(rawProps) {
                return []
            },
        },
    },
    components: {
        DateRangePicker,
    },
    data() {
        let startDate = moment().startOf('month').toDate()
        let endDate = moment().endOf('month').toDate()

        return {
            statusTabs: [
                { text: 'All', value: 'all' },
                { text: 'Pending', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                { text: 'Rejected', value: 'rejected' },
            ],
            showSpinner: false,
            showPagination: true,

            filterStatus: "all",
            filterSearch: "",
            filterOutlet: null,
            filterDate: { startDate, endDate },

            data: [],

            currentPage: 1,
            totalEntries: 0, 
            totalPage: 0, 
            startPage: 1, 
            endPage: 0, 
            perPage: 100, 

            exportHeaders: [], 
            exportData: [], 
            exportFields: {}, 
            exportFileName: "", 
        }
    },
    computed: {
        fields() {
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "staffName", label: "Staff Name", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "applyDate", label: 'Apply Date', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "leaveDate", label: 'Leave Date', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "leaveType", label: 'Leave Type', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "remark", label: 'Remark', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "status", label: 'Status', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "reject", label: 'Reason of Rejection', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "action", label: 'Actions', thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
            ]
        },
    },
    watch: {
        "$i18n.locale"(val) {
            this.setExportData(this.exportData)
        },
        filterStatus(value){
            this.loadData()
        },
        outlets(val) {
            if(!this.filterOutlet) {
                this.filterOutlet = val[0]
                this.loadData();
            }
        },
    },
    methods: {
        getMemberImage(img) {
            return img;
        },
        getDate(date) {
            if(!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('ddd, DD/MM/YYYY')
        },
        getTime(date) {
            if(!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('hh:mmA')
        },
        getDateTime(date) {
            if(!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('DD/MM/YYYY HH:mm:ss')
        },
        getDate2(date) {
            if(!date || !date) {
                return '-'
            }

            let temp = moment.unix(date)
            return temp.format('DD/MM/YYYY')
        },
        getIsRejected(item) {
            return item.rejectedDate || item.startDate <= moment().startOf('day').unix()
        },

        clearFilter() {
            this.filterStatus = 'all'
            this.filterSearch = ""
            this.loadData();
        },
        filterBySearch() {
            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },
        filterByOutlet(val) {
            this.filterOutlet = val
            this.$emit('onOutletChange', val)

            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },
        filterByDate() {
            this.page = 0;
            this.currentPage = 1;
            this.loadData();
        },

        handlePagination(pg) {
            if (pg != null) {
                this.currentPage = pg;
                this.startPage =((pg-1)*100)+1;
                this.endPage = pg * 100;
                if(this.endPage > this.totalEntries){
                    this.endPage = this.totalEntries;
                }
            }
        },

        async loadData() {
            this.showSpinner = true
            this.loadDataImpl(true)
        },

        async loadDataImpl(paging) {
            let url = 'https://staff.tunai.io/business/staff/leave'
            
            let start = moment(this.filterDate.startDate.getTime()).startOf('day').unix()
            let end = moment(this.filterDate.endDate.getTime()).endOf('day').unix()
            url += `?start=${start}&stop=${end}`

            if(paging) {
                url += '&page=' + (this.currentPage - 1)
            }

            if(this.filterOutlet.id !== 'all') {
                url += '&outletID=' + this.filterOutlet.id
            }

            if(this.filterSearch) {
                url += '&search=' + this.filterSearch
            }

            if(this.filterStatus !== 'all') {
                url += '&status=' + this.filterStatus
            }

            await this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() },
            })
            .then((response) => {
                let result = this.data = response.data['leaves']

                var retData = setReturnData(result, result.length, this.currentPage - 1);
                this.totalEntries = result.length;
                this.totalPage = retData.totalPage;
                this.startPage = retData.startPage;
                this.endPage = retData.endPage;

                this.showSpinner = false;

                if(paging) {
                    if(response.data.count > 100) {
                        this.loadDataImpl(false)
                    } else {
                        this.setExportData(result)
                    }
                } else {
                    this.setExportData(result)
                }
            })
            .catch((err) => {
                if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
                    handleSessionExpired();
                    return
                }

                this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
            })
        },

        setExportData(temp) {
            this.exportFields = {}
            this.exportFields["#"] = "index";
            this.exportFields['Name'] = "name"
            this.exportFields['Mobile'] = "mobile"
            this.exportFields['Apply Date'] = "applyDate"
            this.exportFields['Leave Start'] = "startDate"
            this.exportFields['Leave End'] = "stopDate"
            this.exportFields['Leave Type'] = "leaveType"
            this.exportFields['Status'] = "status"
            this.exportFields['Reject Reason'] = "reject"

            this.exportData = [];
            for (var i = 0; i < temp.length; i++) {
                var data = {}
                data["index"] = i + 1;
                data["name"] = temp[i].name
                data["mobile"] = temp[i].mobile
                data["applyDate"] = this.getDateTime(temp[i].createDate)
                data["startDate"] = this.getDate2(temp[i].startDate)
                data["stopDate"] = this.getDate2(temp[i].stopDate)
                data["leaveType"] = temp[i].type

                let status = 'Pending'
                if(temp[i].rejectedDate) {
                    status = 'Rejected'
                } else if(temp[i].approvedDate) {
                    status = 'Approved'
                }
                data["status"] = status
                data["reject"] = temp[i].reject
                this.exportData.push(data)
            }

            var type = this.statusTabs.find(k => k['value'] === this.filterStatus)
            let header = this.$msg.REPORT.HEADER + 'Roster' + " (" + type.text + ")"
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), " "];
            this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV
        },

        showModal(item) {
            this.$emit('editData', item)
        },
    },
    async mounted() {
    }
}
</script>
<style scoped>.link,
.nav-link {
    cursor: pointer;
}</style>